import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {
  addFileGasProject,
  addFileGasProjectSingle,
  getGasProjectFiles,
  getGppByGpId,
  getListProjectProcessEng,
  getUserBalance,
  resetGasProcessFlag,
  resetGasProjectFlag,
  updateGasProjectDetailsNew,
  updateGasProjectEng,
  updateProcessDefectStageNew,
  updateProcessExpertStageNew,
  updateProcessMapStageNew,
  upsertGasProject,
} from "store/actions"
import "./gasProjectEng.scss"
import {
  Card,
  Row,
  Col,
  notification,
  Typography,
  Flex,
  Alert,
  Breadcrumb,
} from "antd"
import {
  HomeOutlined,
  FileSearchOutlined,
  InfoCircleOutlined,
  SafetyOutlined,
} from "@ant-design/icons"
import ListGasProjectProcessEng from "./ListGasProjectProcessEng"

const { Title, Text } = Typography

notification.config({
  duration: 2,
  rtl: true,
})

const GasProjectProcessEng = props => {
  const {
    t,
    matches_sm,
    onResetGasProjectFlag,
    triggerReload,
  } = props
  
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)

  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }

  const [expanded, setExpanded] = useState("")
  const handleChangeExpand = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetGasProjectFlag()
  }, [errorMessage, props.success, props.error])

  return (
    <div className="page-content">
      <MetaTags>
        <title>پرونده | واحد گاز</title>
      </MetaTags>
      {contextHolder}

      {/* Header Card */}
      <Card
        style={{
          borderRadius: 16,
          marginBottom: 16,
          border: "none",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
        }}
        bodyStyle={{ padding: matches_sm ? "16px" : "24px" }}
      >
        <Flex 
          justify="space-between" 
          align="center" 
          wrap="wrap" 
          gap={12}
        >
          <div>
            <Breadcrumb
              style={{ marginBottom: 8 }}
              items={[
                {
                  title: (
                    <span style={{ color: "rgba(255,255,255,0.7)" }}>
                      <HomeOutlined style={{ marginLeft: 4 }} />
                      {t("gasUnit")}
                    </span>
                  ),
                },
                {
                  title: (
                    <span style={{ color: "#fff", fontWeight: 500 }}>
                      پرونده های تخصیص یافته
                    </span>
                  ),
                },
              ]}
            />
            <Title
              level={matches_sm ? 4 : 3}
              style={{
                color: "#fff",
                margin: 0,
                fontWeight: 600,
              }}
            >
              <FileSearchOutlined style={{ marginLeft: 8 }} />
              مدیریت پرونده ها
            </Title>
          </div>
        </Flex>
      </Card>

      {/* Info Alerts */}
      <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
        <Col xs={24} md={12}>
          <Alert
            message={
              <Flex align="center" gap={8}>
                <InfoCircleOutlined />
                <Text>الزامات فقط در مرحله طراحی مربوطه قابل تغییر می باشد.</Text>
              </Flex>
            }
            type="info"
            showIcon={false}
            style={{
              borderRadius: 10,
              border: "1px solid #91caff",
              background: "linear-gradient(135deg, #e6f4ff 0%, #f0f5ff 100%)",
            }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Alert
            message={
              <Flex align="center" gap={8}>
                <SafetyOutlined />
                <Text>لطفا شماره سریال را قبل از تایید بررسی فرمایید.</Text>
              </Flex>
            }
            type="warning"
            showIcon={false}
            style={{
              borderRadius: 10,
              border: "1px solid #ffe58f",
              background: "linear-gradient(135deg, #fffbe6 0%, #fff7e6 100%)",
            }}
          />
        </Col>
      </Row>

      {/* Main Content */}
      <Card
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
        bodyStyle={{ padding: matches_sm ? 12 : 20 }}
      >
        <ListGasProjectProcessEng
          openNotification={openNotification}
          matches_sm={matches_sm}
          expanded={expanded}
          handleChangeExpand={handleChangeExpand}
          reload={triggerReload}
        />
      </Card>
    </div>
  )
}

const mapStateToProps = ({ GasProjects, USERs, GasProjectProcesses }) => ({
  lstProjectProcessEng: GasProjectProcesses.lstProjectProcessEng,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  currentIdGasProject: GasProjects.currentIdGasProject,
  error: GasProjects.error,
  success: GasProjects.success,
  loading: GasProjects.loading,
  userBalance: USERs.userBalance,
  triggerReload: GasProjects.triggerReload + GasProjectProcesses.triggerReload,
})

const mapDispatchToProps = dispatch => ({
  onUpsertGasProject: gasProject => dispatch(upsertGasProject(gasProject)),
  onGetListProjectProcessEng: searchValue =>
    dispatch(getListProjectProcessEng(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onGetUserBalance: () => dispatch(getUserBalance()),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
  onAddFileGasProjectSingle: attachData =>
    dispatch(addFileGasProjectSingle(attachData)),
  onUpdateProcessExpertStageNew: process =>
    dispatch(updateProcessExpertStageNew(process)),
  onUpdateProcessMapStageNew: process =>
    dispatch(updateProcessMapStageNew(process)),
  onUpdateProcessDefectStageNew: process =>
    dispatch(updateProcessDefectStageNew(process)),
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onUpdateGasProjectDetailsNew: process =>
    dispatch(updateGasProjectDetailsNew(process)),
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onResetGasProcessFlag: () => dispatch(resetGasProcessFlag()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GasProjectProcessEng))
